module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "10concur.95008d8c.png" + "?" + Date.now();